import { type ReactNode } from "react";

type ToastVariant = "success" | "error" | "info";

interface ToastProps {
  variant?: ToastVariant;
  message: string;
  onClose: () => void;
}

export function Toast({ variant = "info", message, onClose }: ToastProps) {
  return (
    <div
      className={`xpn-toast xpn-toast--${variant}`}
      onClick={onClose}
      role="alert"
    >
      {message}
    </div>
  );
}

// Simple toast manager hook for React components
let toastId = 0;
const listeners: Array<(toasts: Array<{ id: number; variant: ToastVariant; message: string }>) => void> = [];
let activeToasts: Array<{ id: number; variant: ToastVariant; message: string }> = [];

function notifyListeners() {
  listeners.forEach((fn) => fn([...activeToasts]));
}

export function showToast(message: string, variant: ToastVariant = "info") {
  const id = ++toastId;
  activeToasts = [...activeToasts, { id, variant, message }];
  notifyListeners();

  setTimeout(() => {
    activeToasts = activeToasts.filter((t) => t.id !== id);
    notifyListeners();
  }, 4000);
}

export function subscribeToToasts(
  fn: (toasts: Array<{ id: number; variant: ToastVariant; message: string }>) => void
) {
  listeners.push(fn);
  fn([...activeToasts]);
  return () => {
    const idx = listeners.indexOf(fn);
    if (idx >= 0) listeners.splice(idx, 1);
  };
}

export function ToastContainer() {
  return <div className="xpn-toast-container" id="xpn-toast-container" />;
}